import React from 'react';

export default function WarningIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="42" height="42" rx="21" fill="#DC4405" fillOpacity="0.1" />
      <path
        d="M21 13.5049L21 23.4999"
        stroke="#DC4405"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9941 28.2222H21.0031"
        stroke="#DC4405"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
